var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIcon1(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.897,
    height: 48.928,
    viewBox: "0 0 47.897 48.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1682",
    "data-name": "Rectangle 1682",
    width: 47.897,
    height: 48.928,
    fill: "#ff9ee0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4679",
    "data-name": "Group 4679",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4678",
    "data-name": "Group 4678",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14071",
    "data-name": "Path 14071",
    d: "M30.75,2.33a6.2,6.2,0,0,0-10.164.681L13.517,14.787a3.239,3.239,0,0,1-2.783,1.577H3.515A3.517,3.517,0,0,0,0,19.876V45.415a3.517,3.517,0,0,0,3.515,3.512h32.24a7.16,7.16,0,0,0,6.909-5.277l4.978-18.237a7.171,7.171,0,0,0-6.92-9.049H29.34l2.508-8.375a6.2,6.2,0,0,0-1.1-5.659M23.938,5.019A2.291,2.291,0,0,1,27.7,4.776,2.263,2.263,0,0,1,28.1,6.863l-2.657,8.876a3.509,3.509,0,0,0,3.363,4.53H40.723a3.267,3.267,0,0,1,3.147,4.113L38.893,42.619a3.244,3.244,0,0,1-3.137,2.4H13.027V19.89a7.064,7.064,0,0,0,3.842-3.1ZM9.122,20.269H3.911V45.023H9.122Z",
    transform: "translate(0 0.002)",
    fill: "#ff9ee0",
    fillRule: "evenodd"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon1);
export default __webpack_public_path__ + "static/media/media_icon1.25ce14085a6367fa54414bd0e64d447e.svg";
export { ForwardRef as ReactComponent };